<template>
  <div class="p-grid p-col-12">
    <div class="p-col-12 p-md-7 p-lg-7 no-padding-margin-bottom-top">

      <card class="p-col-12" :header="$t('protocol.tab-general.general-information')" >

        <template #actions>
          <div class="float-right" style="margin-top: -7px;">
            <Tag class="p-mr-2" v-if="protocol.status" :label="$t(`protocol.status.${protocol.status.toLowerCase()}`)" :css-class="getCssStatusProtocol" />
          </div>
        </template>

        <div class="p-col-12">
          <div v-if="protocol.name">
            <h2>{{protocol.name}}</h2>
            <hr />
            <br />
          </div>
          <div class="p-mt-2"><span class="p-mr-1 bold">{{$t('forms.protocol.type-service')}}:</span>{{protocol.typeService.name}}</div>
          <div class="p-mt-2"><span class="p-mr-1 bold">{{$t('forms.protocol.family-name')}}:</span>{{protocol.familyName}}</div>
          <div class="p-mt-2"><span class="p-mr-1 bold">{{$t('field.created')}}:</span>{{$d(new Date(protocol.created), 'long')}}</div>
          <div class="p-mt-2" v-if="protocol.updated"><span class="p-mr-1 bold">{{$t('field.updated')}}:</span>{{$d(new Date(protocol.updated), 'long')}}</div>
        </div>
      </card>

      <card class="p-col-12 force-mb-0" :header="$t('protocol.tab-general.annotation-information')">
        <annotation :entity="protocol" :business="protocolAnnotationBusiness"/>
      </card>

    </div>
    <div class="p-col-12 p-md-5 p-lg-5 no-padding-margin-bottom-top">

      <card class="p-col-12 force-mt-0" :header="$t('protocol.tab-general.stage-information')">
        <div class="p-col-12">

          <div class="p-mt-3" style="display: flex; align-items: center;">
            <Button class="p-mr-2 p-mb-2 p-button p-component" :class="{'p-button-outlined p-button-success': !protocol.stage.color}" :style="stageButtonStyle" @click.prevent="openChangeStageModal">
              <span class="p-button-label">
                <i class="fa-solid fa-shoe-prints p-mr-2"></i>{{protocol.stage.name}}
              </span>
            </Button>
            <a @click.prevent="openChangeStageModal">
              <Tag :label="$t('protocol.change-stage')" style="color: #ffffff" css-class="cursor-pointer info"/>
            </a>
          </div>

          <br/>
          <hr />

          <image-from-server class="avatar p-mr-2 float-left" :src="protocol.currentUser ? protocol.currentUser.avatar : null" />
          <div class="p-mt-2" v-if="protocol.currentUser">
            <span>{{protocol.currentUser.name}}</span>
            <a class="p-ml-2" @click.prevent="openForwardModal">
              <Tag :label="$t(`protocol.forward`)" style="color: #ffffff" css-class="cursor-pointer info"/>
            </a>
          </div>
          <div class="p-mt-2 color-secondary" v-else>
            <span>({{$t('protocol.no-current-user')}})</span>
            <a class="p-ml-2" @click.prevent="openForwardModal">
              <Tag :label="$t(`protocol.forward`)" style="color: #ffffff" css-class="cursor-pointer info"/>
            </a>
          </div>
          
        </div>
      </card>

      <card class="p-col-12" :header="$t('protocol.tab-general.actions-information')" v-if="!(loggedUser.typeUser === limited && protocol.status === 'CANCELED')">
        <div class="p-col-12">
          <Button style="min-width: 100%" class="p-button-outlined p-mr-2 p-mb-2 p-button p-component" @click.prevent="getHtmlBudget" v-if="protocol.status !== 'CANCELED'">
            <span class="p-button-label">
              <i class="fa-solid fa-print p-mr-2"></i>{{$t('protocol.tab-general.actions.print-budget-simple')}}
            </span>
          </Button>
          <Button style="min-width: 100%" class="p-button-outlined p-mr-2 p-mb-2 p-button p-component" @click.prevent="printBudget" v-if="protocol.status !== 'CANCELED'">
            <span class="p-button-label">
              <i class="pi pi-print p-mr-2"></i>{{$t('protocol.tab-general.actions.print-budget')}}
            </span>
          </Button>
          <Button style="min-width: 100%" class="p-button-outlined p-button-secondary p-mr-2 p-mb-2 p-button p-component" @click.prevent="printContracts" v-if="protocol.status !== 'CANCELED'">
            <span class="p-button-label">
              <i class="fa fa-file-signature p-mr-2"></i>{{$t('protocol.tab-general.actions.print-contracts')}}
            </span>
          </Button>
          <Button style="min-width: 100%" class="p-button-outlined p-button-danger p-mr-2 p-mb-2 p-button p-component" @click.prevent="cancel" v-if="loggedUser.typeUser !== limited && protocol.status === 'ACTIVE'">
            <span class="p-button-label">
              <i class="fas fa-check p-mr-2"></i>{{$t('protocol.tab-general.actions.cancel')}}
            </span>
          </Button>
          <Button style="min-width: 100%" class="p-button-outlined p-button-success p-mr-2 p-mb-2 p-button p-component" @click.prevent="finalize" v-if="loggedUser.typeUser !== limited && !protocol.budget && protocol.status === 'ACTIVE'">
            <span class="p-button-label">
              <i class="fas fa-check p-mr-2"></i>{{$t('protocol.tab-general.actions.finalize')}}
            </span>
          </Button>
          <Button style="min-width: 100%" class="p-button-outlined p-button-warning p-mr-2 p-mb-2 p-button p-component" @click.prevent="reactive" v-if="loggedUser.typeUser !== limited && protocol.status !== 'ACTIVE'">
            <span class="p-button-label">
              <i class="fas fa-check p-mr-2"></i>{{$t('protocol.tab-general.actions.reactive')}}
            </span>
          </Button>
          <Button style="min-width: 100%" class="p-button-outlined p-mr-2 p-mb-2 p-button p-component" @click.prevent="budgetToProtocol" v-if="loggedUser.typeUser !== limited && protocol.status !== 'CANCELED' && protocol.budget">
            <span class="p-button-label">
              <i class="fas fa-file-contract p-mr-2"></i>{{$t('protocol.tab-general.actions.protocol')}}
            </span>
          </Button>
        </div>
      </card>

    </div>

  </div>
</template>

<script>
import ImageFromServer from "@/components/image/ImageFromServer";
import Annotation from "@/components/annotation/Annotation";
import ProtocolAnnotationsBusiness from "@/business/ProtocolAnnotationsBusiness";
import ProtocolBusiness from "@/business/ProtocolBusiness";
import Tag from "@/components/tag/Tag";
import DialogService from "@/business/ModalBusiness";
import ModalForwardProtocol from "@/viewer/protocol/ModalForwardProtocol";
import ModalChangeStageProtocol from "@/viewer/protocol/ModalChangeStageProtocol";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
import ModalEditBudget from "@/viewer/protocol/ModalEditBudget";
import ModalPrintContract from "@/viewer/protocol/ModalPrintContract";
import ModalPrintBudgetSelection from "@/viewer/protocol/ModalPrintBudgetSelection";
import {LIMITED} from "@/constants/TypeUser";
import store from "@/store";
import StageBusiness from "@/business/StageBusiness";

export default {
  name: "TabGeneralProtocol",
  components: {Tag, Annotation, ImageFromServer},

  props:{
    protocol: {type: Object, default: () => {return {}}},
  },

  computed: {

    getCssStatusProtocol(){
      switch (this.protocol.status){
        case 'FINISHED': return 'success';
        case 'CANCELED': return 'danger';
        default: return 'info'
      }
    },

    stageButtonStyle(){
      if(!this.protocol.stage.color){
        return null;
      }
      return {
        backgroundColor: this.protocol.stage.color,
        borderColor: this.protocol.stage.color,
        color: StageBusiness.contrastColor(this.protocol.stage.color),
      };
    },

  },

  data(){
    return{
      limited: LIMITED,
      loggedUser: store.getLoggedUser(),
      protocolAnnotationBusiness: ProtocolAnnotationsBusiness,
    }
  },

  methods:{

    async getHtmlBudget(){
      let htmlBudget = await ProtocolBusiness.getHtmlBudget(this.protocol.id);
      const finalBudget = await DialogService.openModal(ModalEditBudget, {originalBudget: htmlBudget});
      if(finalBudget) {
        await ProtocolBusiness.printBudget(this.protocol.id, finalBudget);
      }
    },

    async printBudget(){
      const selectedProtocols = await DialogService.openModal(ModalPrintBudgetSelection, {protocol: this.protocol});
      if(selectedProtocols) {
        await ProtocolBusiness.printPdfBudget(this.protocol.id, selectedProtocols);
      }
    },

    async printContracts(){
      const totalPricePerClientDTO = await DialogService.openModal(ModalPrintContract, {protocol: this.protocol});
      if(totalPricePerClientDTO) {
        await ProtocolBusiness.printContracts(this.protocol, totalPricePerClientDTO);
      }
    },

    async reactive(){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.reactive(this.protocol.id);
        if(response){
            this.protocol.status = 'ACTIVE';
        }
      }
    },

    async budgetToProtocol(){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.budgetToProtocol(this.protocol.id);
        if(response){
          window.location.reload();
        }
      }
    },

    async cancel(){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.cancel(this.protocol.id);
        if(response){
          this.protocol.status = 'CANCELED';
        }
      }
    },

    async finalize(){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.finalize(this.protocol.id);
        if(response){
          this.protocol.status = 'FINISHED';
        }
      }
    },

    async openForwardModal(){
      const response = await DialogService.openModal(ModalForwardProtocol, {protocol: this.protocol});
      if(response) {
        this.$set(this.protocol, 'currentUser', response);
      }
    },

    async openChangeStageModal(){
      const response = await DialogService.openModal(ModalChangeStageProtocol, {protocol: this.protocol});
      if(response) {
        this.$set(this.protocol, 'stage', response);
      }
    },

  }

}
</script>

<style scoped>
  .no-padding-margin-bottom-top {
    padding-top: 0 !important;
    margin-top: 0 !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

  .force-mb-0 {
    margin-bottom: 0rem !important;
  }

  .force-mt-0 {
    margin-bottom: 0rem !important;
  }

  .avatar {
    width: 55px;
    border-radius: 80px;
  }

  .cursor-pointer {
    cursor: pointer !important;
  }

  .stage-badge {
    pointer-events: none;
    cursor: default;
  }

</style>